import * as React from "react";
import { RouteType } from "src/routes/config";

// Icons
import { Home, TrendingUp, Assignment, ShowChart, BarChart, AdminPanelSettings, People, Security, Folder, History } from "@mui/icons-material";

// Lista de funciones con ID
import FunctionsEnum from "../models/enum/FunctionEnum";

// Pages
const HomePage = React.lazy(() => import("./HomePage"));
const WorkloadPage = React.lazy(() => import("./WorkloadPage"));
const ForecastPage = React.lazy(() => import("./WorkloadPage/ForecastPage"));
const ForecastDetailPage = React.lazy(() => import("./WorkloadPage/ForecastPage/ForecastDetailPage"));
const BaselinePage = React.lazy(() => import('./WorkloadPage/BaselinePage'));
const BaselineDetailPage = React.lazy(() => import('./WorkloadPage/BaselinePage/BaselineDetailPage'));
const ForecastDashboardPage = React.lazy(() => import("./WorkloadPage/ForecastDashboardPage"));
const ProjectPage = React.lazy(() => import("./ProjectPage"));
const DocumentPage = React.lazy(() => import("./ProjectPage/DocumentPage/index"));
const SyncPage = React.lazy(() => import("./ProjectPage/SyncPage/index"));
const UserPage = React.lazy(() => import("./AdministrationPage/UserPage"));
const AdministrationPage = React.lazy(() => import("./AdministrationPage"));
const AdminProjectPage = React.lazy(() => import("./AdministrationPage/ProjectPage"));
const RolesPage = React.lazy(() => import("./AdministrationPage/RolesPage"));
const TransactionLogPage = React.lazy(() => import("./AdministrationPage/TransactionLogPage"));
const ExpiredDocsStatus = React.lazy(() => import("./ProjectPage/DelayedDocsPage"));

// TODO Agregar las rutas del sitio en esta sección
const pagesRoutes: RouteType[] = [
  {
    index: true,
    element: <HomePage />,
    state: "home",
    path: "/",
    sidebarProps: {
      displayText: "home",
      icon: <Home />
    },
    functionId: -1,
  },
  {
    index: true,
    element: <ProjectPage />,
    state: "project",
    path: "/project",
    sidebarProps: {
      displayText: "project",
      icon: <TrendingUp />
    },
    functionId: FunctionsEnum.Projects,
  },
  {
    element: <WorkloadPage />,
    state: "WorkloadManagement",
    path: "/workload",
    sidebarProps: {
      displayText: "Workload",

      icon: <Assignment />
    },
    functionId: -1,
    child: [
      {
        index: true,
        element: <ForecastPage />,
        state: "WorkloadForecast",
        path: "/workload/forecast",
        requiredSubModule: "WorkloadForecast",
        sidebarProps: {
          displayText: "Forecast",
          icon: <ShowChart />
        },
        functionId: -1,
      },
      {
        index: true,
        element: <ForecastDetailPage />,
        state: "workload-forecast-detail",
        path: "/workload/forecast/:projectId",
        requiredSubModule: "WorkloadForecast",
        functionId: -1,
      },
      {
        index: true,
        element: <ForecastDashboardPage />,
        state: "workload-forecast-dashboard",
        path: "/workload/forecast-dashboard",
        requiredFeature: "ForecastDashboard",
        functionId: -1,
      },
      {
        index: true,
        element: <BaselinePage />,
        state: "workload-baseline",
        path: "/workload/baseline",
        requiredSubModule: "WorkloadBaseline",
        sidebarProps: {
          displayText: "Baseline",
          icon: <BarChart />
        },
        functionId: -1,
      },
      {
        index: true,
        element: <BaselineDetailPage />,
        state: "workload-baseline-detail",
        path: "/workload/baseline/:projectId",
        requiredSubModule: "WorkloadBaseline",
        functionId: -1,
      },
    ],
  },
  {
    element: <AdministrationPage />,
    state: "administration",
    path: "/administration",
    sidebarProps: {
      displayText: "Administration",
      icon: <AdminPanelSettings />
    },
    functionId: -1,
    child: [
      {
        index: true,
        element: <UserPage />,
        state: "administration-user",
        path: "/administration/user",
        requiredSubModule: "AdministrationUser",
        sidebarProps: {
          displayText: "User",
          icon: <People />
        },
        functionId: -1,
      },
      {
        index: true,
        element: <RolesPage />,
        state: "administration-roles",
        path: "/administration/roles",
        requiredSubModule: "AdministrationRol",
        sidebarProps: {
          displayText: "Roles",
          icon: <Security />
        },
        functionId: -1,
      },
      {
        index: true,
        element: <AdminProjectPage />,
        state: "administration-projects",
        path: "/administration/projects",
        requiredSubModule: "AdministrationProject",
        sidebarProps: {
          displayText: "Projects",
          icon: <Folder />
        },
        functionId: -1,
      },
    ],
  },
  {
    index: true,
    element: <TransactionLogPage />,
    state: "administration-transaction-log",
      path: "/administration/transaction-log",
      requiredSubModule: "TransactionLog",
    sidebarProps: {
      displayText: "transaction_log",
      icon: <History />
    },
    functionId: -1,
  },
  {
    index: true,
    element: <DocumentPage />,
    state: "document",
    path: "/project/document",
    functionId: FunctionsEnum.EditProject
  },
  {
    index: true,
    element: <DocumentPage />,
    state: "document",
    path: "/project/detail",
    functionId: FunctionsEnum.ProjectDetail
  },
  {
    index: true,
    element: <ExpiredDocsStatus />,
    state: "document",
    path: "/project/:projectId/expireddocs",
    functionId: FunctionsEnum.ProjectDetail
  },
  {
    index: true,
    element: <SyncPage />,
    state: "sync",
    path: "/project/sync",
    functionId: FunctionsEnum.SynchronizationList
  },
  ]

export default pagesRoutes;
